module.exports = __webpack_public_path__ + "img/faq_mobile-02.444cb564.svg";